import { useFormatter, useIntl } from '@capsicum/common';
import { useMainCurrenciesQuery } from '@capsicum/socios-core';

export const useNCWInsufficientChzDrawer = () => {
	const { $t } = useIntl();
	const { formatCrypto } = useFormatter();

	//retrieve the user's default and alternate currencies
	const { data: currencies } = useMainCurrenciesQuery();
	const defaultShortCode = currencies?.defaultCurrency?.shortCode ?? 'CHZ';
	const altShortCode = currencies?.altCurrency?.shortCode ?? 'EUR';

	//format 0 balance in default and alternate currencies
	const zeroDefaultBalance = formatCrypto(0, defaultShortCode);
	const zeroAltBalance = formatCrypto(0, altShortCode);

	return {
		intlText: {
			description: $t('ncWallet.send.insufficientChzDrawer.description'),
			primaryButtonText: $t('ncWallet.send.insufficientChzDrawer.primaryButtonText'),
			secondaryButtonText: $t('ncWallet.send.insufficientChzDrawer.secondaryButtonText'),
			title: $t('ncWallet.send.insufficientChzDrawer.title'),
			yourBalance: $t('ncWallet.send.insufficientChzDrawer.yourBalance')
		},
		zeroAltBalance,
		zeroDefaultBalance
	};
};
